import React from 'react';
import PropTypes from 'prop-types';

import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import { RaisedButton, FlatButton, Dialog } from 'material-ui';

import { getMailRecognizeSpamList } from 'actions/preferences/mailRecognizeSpamList';
import { updatePreference } from 'actions/preferences/index';

const styles = {
    dialog: {
        contentStyle: {
            width: '100%',
            maxWidth: 'none',
        }
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' },
    },
    textarea: {
        style: {
            width: '100%',
            minHeight: '400px',
        }
    },
};

class AddMailRecognizeSpam extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            text: '',
        };

        this.toggleDialog = this.toggleDialog.bind(this);

        this.savePostMailRecognizeSpam = this.savePostMailRecognizeSpam.bind(this);
        this.changeTextLetterText = this.changeTextLetterText.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!nextProps.preferences.isLoaded) {
            return;
        }

        const preferences = nextProps.preferences.items.filter((item) => {
            return item.type === 'mailRecognizeSpamList';
        });

        this.setState({
            text: preferences[0] ? preferences[0].mailRecognizeSpamList.join('\n') : '',
        });
    }

    savePostMailRecognizeSpam() {
        const { text } = this.state;

        this.props.updatePreference(text.split('\n'), this.props.preferences.items[0]._id)
    }

    changeTextLetterText(e) {
        this.setState({
            text: e.target.value,
        });
    }

    toggleDialog() {
        if (!this.state.open) {
            this.props.getMailRecognizeSpamList();
        }

        this.setState({
            open: !this.state.open,
        });
    }
    
    render() {
        const { open, text } = this.state;

        const actions = [
            <FlatButton
                label='SAVE'
                primary
                onClick={() => {
                    this.savePostMailRecognizeSpam();
                }}
            />,
            <FlatButton
                label='CLOSE'
                primary
                onClick={this.toggleDialog}
            />,
        ];

        return (
            <div className="btn">
                <RaisedButton
                    onClick={this.toggleDialog}
                    label='Recognize spam'
                    labelStyle={styles.button.labelStyle}
                    style={styles.button.style}
                    buttonStyle={styles.button.buttonStyle}
                    primary
                />

                <Dialog
                    title='Edit recognize spam'
                    actions={actions}
                    contentStyle={styles.dialog.contentStyle}
                    open={open}
                >
                    <textarea
                        style={styles.textarea.style}
                        value={text}
                        onChange={this.changeTextLetterText}
                    />
                </Dialog>
            </div>
        );
    }
}

export default connect(
    ({ preferences }) => {

        return {
            preferences,
        };
    },
    dispatch => bindActionCreators({
        getMailRecognizeSpamList,
        updatePreference,
    }, dispatch),
)(AddMailRecognizeSpam);


// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Management/AddMailRecognizeSpam.jsx